



































































































































import Vue from 'vue';
import VueMultianalytics from 'vue-multianalytics';
import VueAnalytics, { onAnalyticsReady } from 'vue-analytics';
import { mapGetters } from 'vuex';
import { TRACK_TYPES } from '@/dex-shared/helpers/track';
import DescomplicaHeader from '@/components/DescomplicaHeader.vue';
import DescomplicaSidebar from '@/components/DescomplicaSidebar.vue';
import DescomplicaFooter from '@/components/DescomplicaFooter.vue';
import ToggleExperience from '@/components/ToggleExperience.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import Navbar from './components/Navbar.vue';

export default Vue.extend({
  components: {
    Navbar,
    DescomplicaHeader,
    DescomplicaSidebar,
    ToggleExperience,
    DescomplicaFooter,
    Loading,
  },
  computed: {
    ...mapGetters({
      userId: 'userId',
      currentUser: 'currentUser',
      userShouldSeeDexEssays: 'userShouldSeeDexEssays',
    }),
    isRNWebView: function() {
      return window.isRNWebView == true;
    },
  },
  mounted() {
    this.$track(TRACK_TYPES.INTEGRATION_NAVIGATE, {
      integration: 'imaginie',
    });
    this.$track(TRACK_TYPES.INTEGRATION_VIEWED, {
      integration: 'imaginie',
      type: 'Ready',
    });
  },
});
